import React, { useState, useEffect } from "react";
import Input from "../../atoms/Input/Input";
import { useLocation, useNavigate } from "react-router-dom";
import { DateTimeHelper } from "../../../helpers/DateTimeHelper";
import FormCountryCodes from "./FormCountryCodes";
import useRequest from "../../../context/useRequest";
import { useAuth } from "../../../context/AuthContext";

const TripDetailsForm = () => {
  const { isAuthenticated, userId } = useAuth();
  const baseURL = process.env.REACT_APP_API_BASE_URL;
  const navigate = useNavigate();
  const location = useLocation();
  const { data: isTravelerData, sendRequest } = useRequest();
  const { data: isprocessBookingData, sendRequest: processBookingRequest } =
    useRequest();
  const { bookingToken } = location.state;
  const [paymentMethodSelected, setPaymentMethodSelected] = useState(false);
  const [isDataProcessed, setIsDataProcessed] = useState(false);
  const [isTripDetails, setIsTripDetails] = useState({
    title: "",
    first_name: "",
    last_name: "",
    email: "",
    phone: "",
    country_code: "",
    trip_t_c: false,
  });
  const [isSubmitting, setIsSubmitting] = useState(false);
  const [isProcessingPayment, setIsProcessingPayment] = useState(false);
  const [isPaymentStarted, setIsPaymentStarted] = useState(false);
  const [showModal, setShowModal] = useState(false);
  const [isFieldErrors, setIsFieldErrors] = useState({});
  // const [isprocessBooking, setIsProcessBooking] = useState({})
  // console.log(isprocessBooking)
  const [selectedPG, setSelectedPG] = useState({
    code: "",
    name: "",
    convenience_type: "flat",
    convenience_value: 0,
    actual_convenience_value: 0,
  });

  useEffect(() => {
    if (isTravelerData && isTravelerData.data) {
      setIsTripDetails((prev) => {
        return JSON.stringify(prev) === JSON.stringify(isTravelerData.data)
          ? prev
          : { ...prev, ...isTravelerData.data };
      });
    }
  }, [isTravelerData]);
  useEffect(() => {
    if (isprocessBookingData && isprocessBookingData.data && !isDataProcessed) {
      setIsDataProcessed(true);
      setIsTripDetails((prev) => ({
        ...prev,
        ...isprocessBookingData.data,
      }));
    }
  }, [isprocessBookingData, isDataProcessed]);

  const tripDetailsHandler = (e) => {
    const { name, type, value, checked } = e.target;
    setIsTripDetails((prev) => ({
      ...prev,
      // [name]: value || "",
      [name]: type === "checkbox" ? checked : value, // Fix for checkbox handling
    }));
    setIsFieldErrors((prev) => ({
      ...prev,
      [name]: " ",
    }));

    // // Clear error when checkbox is checked
    // if (name === "trip_t_c") {
    //   setIsFieldErrors((prev) => ({
    //     ...prev,
    //     trip_t_c: checked ? "" : prev.trip_t_c,
    //   }));
    // }

    if (name === "email") {
      // Logged-in users don't need email verification
      if (isAuthenticated) {
        setIsEmailVerified(true);
        return;
      }
      setIsEmailVerified(false);
      setShowOtpInput(false);
      setVerificationId(null);
      setOtp("");
      setEmailVerificationMessage("");
    }    
  };

  const handleCloseModal = async () => {
    console.log("Modal closing and resetting form");
    const paymentToken = isTravelerData?.data?.payment_token || 0;

    if (paymentToken) {
      try {
        const formData = new FormData();
        formData.append("payment_token", paymentToken);

        const response = await processBookingRequest({
          method: "POST",
          url: "/cab/holdPayment",
          body: formData,
        });

        console.log("Cancel Payment Response:", response);

      } catch (error) {
        console.error("Error cancelling payment:", error);
      }
    }
    setShowModal(false);
    // setIsTripDetails({
    //   title: '',
    //   first_name: '',
    //   last_name: '',
    //   email: '',
    //   phone: '',
    //   country_code: '',
    // });
    setIsFieldErrors({});
  };
  const tripSubmitHandler = async (e) => {
    e.preventDefault();
     if (isSubmitting) return;
     setIsSubmitting(true);
    const formTraveler = new FormData();
    formTraveler.append("title", isTripDetails.title);
    formTraveler.append("first_name", isTripDetails.first_name);
    formTraveler.append("last_name", isTripDetails.last_name);
    formTraveler.append("email", isTripDetails.email);
    formTraveler.append("country_code", isTripDetails.country_code);
    formTraveler.append("phone", isTripDetails.phone);
    formTraveler.append("booking_token", bookingToken);
    formTraveler.append("corporate_id", '1474');
    formTraveler.append("vfsGlobalId", null);
    formTraveler.append("booking_source","B2C")


    try {
      const response = await sendRequest({
        method: "POST",
        url: "/cab/createBooking",
        body: formTraveler,
      });

      if (response.status == true && isTripDetails.trip_t_c) {
        setShowModal(true);
      } else {
        if (response?.errors) {
          setIsFieldErrors(response?.errors);
          if (!isTripDetails.trip_t_c) {
            setIsFieldErrors((prev) => ({
              ...prev,
              trip_t_c: "You must agree to the Terms and Conditions",
            }));
          }
        } else if (!isTripDetails.trip_t_c) {
          setIsFieldErrors((prev) => ({
            ...prev,
            trip_t_c: "You must agree to the Terms and Conditions",
          }));
        } else {
          navigate("/booking-response", {
            state: { serverResponse: response },
          });
        }
      }
    } catch (errorMessage) {
      console.log(errorMessage);
      alert("An unexpected error occurred. Please try again.");

      setIsFieldErrors({ message: "Something went wrong. Please try again." });
    }
    finally{
      setIsSubmitting(false);
    }
  };

  const handlePGChange = (paymentMethod, baseFare) => {
    if (paymentMethod) {
      if (
        "code" in paymentMethod &&
        "name" in paymentMethod &&
        "convenience_type" in paymentMethod &&
        "convenience_value" in paymentMethod
      ) {
        paymentMethod.convenience_value = parseFloat(
          paymentMethod.convenience_value
        );

        let act_convenience_value = paymentMethod.convenience_value;

        if (paymentMethod.convenience_type == "percentage") {
          act_convenience_value =
            (paymentMethod.convenience_value * baseFare) / 100;
        }

        const tempSelectedPG = {
          code: paymentMethod.code,
          name: paymentMethod.name,
          convenience_type: paymentMethod.convenience_type,
          convenience_value: paymentMethod.convenience_value,
          actual_convenience_value: act_convenience_value,
        };

        setSelectedPG(tempSelectedPG);
        setPaymentMethodSelected(true);
      }
    } else {
      setPaymentMethodSelected(false);
    }
  };

  const handlePayment = async () => {
    const paymentToken = isTravelerData?.data?.payment_token || 0;
    const loadScript = (onLoadCallback) => {
      const src = `${baseURL}/payment/paymentJsLib`;
      if (document.querySelector(`script[src="${src}"]`)) {
        console.log("Script already loaded");
        onLoadCallback();
        return;
      }
      const script = document.createElement("script");
      script.src = src;
      script.async = true;

      script.onload = () => {
        console.log("Script loaded successfully");
        if (typeof window.CustomPaymentGateway !== "function") {
          alert("Payment gateway library failed to load.");
          return;
        }
        onLoadCallback();
      };

      script.onerror = () => {
        console.error("Failed to load the Payment Gateway script");
        alert(
          "There was an error loading the payment gateway. Please try again later."
        );
      };

      document.body.appendChild(script);
    };

    const paynow = () => {
      setIsPaymentStarted(true);
      const config = {
        paymentToken,
        paymentGateway: selectedPG.code,
        handleResponse: async (response) => {
          // console.log("Received response:", response);
          setIsProcessingPayment(true);
          try {
            const formPayment = new FormData();
            formPayment.append("payment_token", paymentToken);

            const serverResponse = await processBookingRequest({
              method: "POST",
              url: "/cab/processBooking",
              body: formPayment,
            });
            navigate("/booking-response", {
              state: { serverResponse: serverResponse },
            });
          } catch (error) {
            console.error("Error processing payment:", error);
            setIsFieldErrors({
              message:
                "An error occurred while processing your payment. Please try again later.",
            });
             setIsPaymentStarted(false);
          }finally {
          setIsProcessingPayment(false);
        }
        },
      };
      const payment = new window.CustomPaymentGateway(config);
      payment.openPaymentWindow();
    };

    loadScript(paynow);
  };


  const priceFormat = (price) => {
    if (isNaN(price)) return "0";
    return new Intl.NumberFormat("en-IN", {
      style: "currency",
      currency: "INR",
      minimumFractionDigits: 0,
      maximumFractionDigits: 2,
    }).format(price);
  };

  // CODE ADDED FOR EMAIL VALIDATION PART START
  const [isEmailVerified, setIsEmailVerified] = useState(false);
  const [isSendingVerification, setIsSendingVerification] = useState(false);
  const [isVerifyingOtp, setIsVerifyingOtp] = useState(false);

  const [verificationId, setVerificationId] = useState(null);
  const [otp, setOtp] = useState("");

  const [showOtpInput, setShowOtpInput] = useState(false);

  const [emailVerificationMessage, setEmailVerificationMessage] =
      useState("");

  const {
      sendRequest: emailVerificationRequest
  } = useRequest();

  const handleValidateEmail = async () => {
      const email = isTripDetails.email?.trim();

      if (!email) {
          setIsFieldErrors((prev) => ({
              ...prev,
              email: "Please enter your email address.",
          }));
          return;
      }

      const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;

      if (!emailRegex.test(email)) {
          setIsFieldErrors((prev) => ({
              ...prev,
              email: "Please enter a valid email address.",
          }));
          return;
      }

      setIsSendingVerification(true);
      setEmailVerificationMessage("");

      try {
          const formData = new FormData();

          formData.append(
              "module_type",
              "cab_booking"
          );

          formData.append(
              "email",
              email
          );

          const response = await emailVerificationRequest({
              method: "POST",
              url: "/email-verification/send",
              body: formData,
          });

          if (response.status === true) {

              setVerificationId(response.verification_id);

              setShowOtpInput(true);

              setOtp("");

              setEmailVerificationMessage(
                  "A 6-digit verification code has been sent to your email."
              );

          } else {

              setEmailVerificationMessage(
                  response.message ||
                  "Unable to send verification OTP."
              );
          }

      } catch (error) {

          console.error(error);

          setEmailVerificationMessage(
              error?.message ||
              "Unable to send verification OTP. Please try again."
          );

      } finally {
          setIsSendingVerification(false);
      }
  };

  const handleVerifyOtp = async () => {

      if (!verificationId) {
          setEmailVerificationMessage(
              "Please request a new verification code."
          );
          return;
      }

      if (!otp || otp.length !== 6) {
          setEmailVerificationMessage(
              "Please enter the 6-digit OTP."
          );
          return;
      }

      setIsVerifyingOtp(true);
      setEmailVerificationMessage("");

      try {

          const formData = new FormData();

          formData.append(
              "verification_id",
              verificationId
          );

          formData.append(
              "email",
              isTripDetails.email.trim()
          );

          formData.append(
              "otp",
              otp
          );

          const response = await emailVerificationRequest({
              method: "POST",
              url: "/email-verification/verify",
              body: formData,
          });

          if (
              response.status === true &&
              response.verified === true
          ) {

              setIsEmailVerified(true);

              setShowOtpInput(false);

              setEmailVerificationMessage(
                  "✓ Email verified successfully."
              );

          } else {

              setEmailVerificationMessage(
                  response.message ||
                  "Invalid OTP. Please try again."
              );
          }

      } catch (error) {
        console.error("OTP verification error:", error);
        const message =
            error?.response?.data?.message ||
            error?.data?.message ||
            "Unable to verify OTP. Please try again.";

        setEmailVerificationMessage(message);
      } finally {
          setIsVerifyingOtp(false);
      }
  };
  useEffect(() => {
    if (isAuthenticated && isTripDetails.email) {
      setIsEmailVerified(true);
      setShowOtpInput(false);
      setEmailVerificationMessage("");
    }
  }, [isAuthenticated, isTripDetails.email]);

  const checkEmailVerification = async (email) => {
    if (!email?.trim()) {
      return;
    }

    // Logged-in users don't need OTP
    if (isAuthenticated) {
      setIsEmailVerified(true);
      return;
    }

    try {
      const response = await emailVerificationRequest({
        method: "POST",
        url: `/email-verification/status?email=${encodeURIComponent(
          email.trim()
        )}&module_type=cab_booking`,
      });

      if (response?.status === true && response?.verified === true) {
        setIsEmailVerified(true);
        setShowOtpInput(false);
        setVerificationId(null);
        setOtp("");
        setEmailVerificationMessage("✓ Email already verified.");
      } else {
        setIsEmailVerified(false);
        setEmailVerificationMessage("");
      }
    } catch (error) {
      console.error("Email verification status error:", error);

      setIsEmailVerified(false);
    }
  };    
  useEffect(() => {
    const email = isTripDetails.email?.trim();

    if (!email) {
      return;
    }
    const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;

    if (!emailRegex.test(email)) {
        setIsFieldErrors((prev) => ({
            ...prev,
            email: "Please enter a valid email address.",
        }));
        return;
    }

    if (isAuthenticated) {
      setIsEmailVerified(true);
      return;
    }

    checkEmailVerification(email);
  }, [isTripDetails.email, isAuthenticated]);  
  // CODE ADDED FOR EMAIL VALIDATION PART END

  return (
    <section className="confirm-section--tripDetails">
    
        <h3 className="h4 mb-3">Traveler Information</h3>
        <form
          onSubmit={tripSubmitHandler}
          className="confirm-section--tripDetails-form "
        >
          <div className="confirm-section--tripDetails-form-itemTwo">
            <div className="input-group w-100 ">
              <label>
                Select Title <span style={{ color: "red" }}>*</span>
              </label>
              <select
                className="name_title"
                name="title"
                value={isTripDetails.title}
                onChange={tripDetailsHandler}
              >
                <option>Please select</option>
                <option value="Mr">Mr</option>
                <option value="Ms">Ms</option>
                <option value="Mrs">Mrs</option>
              </select>
              {isFieldErrors.title && (
                <p className="error-message">{isFieldErrors.title}</p>
              )}
            </div>
            <div className="input-group ">
              <Input
                type="text"
                name="first_name"
                placeholder="First Name"
                value={isTripDetails.first_name}
                onChange={tripDetailsHandler}
                className="form-control"
                label={
                  <span>
                    First Name <span style={{ color: "red" }}>*</span>
                  </span>
                }
              />
              {isFieldErrors.first_name && (
                <p className="error-message">{isFieldErrors.first_name}</p>
              )}
            </div>
            <div className="input-group ">
              <Input
                type="text"
                name="last_name"
                placeholder="Last Name"
                value={isTripDetails.last_name}
                onChange={tripDetailsHandler}
                className="form-control"
                label={
                  <span>
                    Last Name <span style={{ color: "red" }}>*</span>
                  </span>
                }
              />
              {isFieldErrors.last_name && (
                <p className="error-message">{isFieldErrors.last_name}</p>
              )}
            </div>
<div className="input-group w-100">

    <label>
        Email <span style={{ color: "red" }}>*</span>
    </label>

    <div className="d-flex gap-2 w-100">

        <Input
            type="email"
            name="email"
            placeholder="Email"
            value={isTripDetails.email}
            onChange={tripDetailsHandler}
            className="form-control"
            // disabled={isEmailVerified}
        />

        {!isAuthenticated && !isEmailVerified && (
            <button
                type="button"
                className="btn btn-outline-success"
                onClick={handleValidateEmail}
                disabled={
                    isSendingVerification ||
                    !isTripDetails.email
                }
            >
                {isSendingVerification
                    ? "Sending..."
                    : showOtpInput
                    ? "Resend OTP"
                    : "Validate Email"}
            </button>
        )}

        {!isAuthenticated&&isEmailVerified && (
            <button
                type="button"
                className="btn btn-success"
                disabled
            >
                ✓ Verified
            </button>
        )}

    </div>

    {isFieldErrors.email && (
        <p className="error-message">
            {isFieldErrors.email}
        </p>
    )}

    {showOtpInput && !isEmailVerified && (
        <div className="mt-3">

            <label>
                Enter OTP
            </label>

            <div className="d-flex align-items-center gap-2">

                <input
                    type="text"
                    inputMode="numeric"
                    maxLength={6}
                    value={otp}
                    onChange={(e) => {
                        const value = e.target.value
                            .replace(/\D/g, "")
                            .slice(0, 6);

                        setOtp(value);
                    }}
                    placeholder="Enter 6-digit OTP"
                    className="form-control"
                />

                <button
                    type="button"
                    className="btn btn-outline-success"
                    onClick={handleVerifyOtp}
                    disabled={
                        isVerifyingOtp ||
                        otp.length !== 6
                    }
                >
                    {isVerifyingOtp
                        ? "Verifying..."
                        : "Verify OTP"}
                </button>

            </div>

            <small className="text-muted d-block mt-2">
                Enter the 6-digit code sent to your email.
            </small>

        </div>
    )}

    {emailVerificationMessage && (
        <p
            className="mt-2"
            style={{
                color: isEmailVerified
                    ? "green"
                    : "#666",
            }}
        >
            {emailVerificationMessage}
        </p>
    )}

  {!isAuthenticated && !isEmailVerified && (
      <div
          className="mt-2 p-2"
          style={{
              backgroundColor: "#f8f9fa",
              border: "1px solid #ddd",
              borderRadius: "4px",
              fontSize: "14px",
          }}
      >
          <strong>Already registered?</strong>{" "}
          Please{" "}
          <button
              type="button"
              className="btn btn-link p-0"
              onClick={() => navigate("/login")}
              style={{
                  textDecoration: "none",
                  fontWeight: "600",
              }}
          >
              Login
          </button>{" "}
          to continue without email OTP verification.
      </div>
  )}
</div>
            <div className="input-group ">
              <FormCountryCodes
                name="country_code"
                value={isTripDetails.country_code}
                onChange={tripDetailsHandler}
              />
              {isFieldErrors.country_code && (
                <p className="error-message">{isFieldErrors.country_code}</p>
              )}
            </div>

            <div className="input-group ">
              <Input
                type="text"
                name="phone"
                placeholder="Contact Number"
                value={isTripDetails.phone}
                onChange={tripDetailsHandler}
                className="form-control"
                label={
                  <span>
                    Contact Number <span style={{ color: "red" }}>*</span>
                  </span>
                }
              />
              {isFieldErrors.phone && (
                <p className="error-message">{isFieldErrors.phone}</p>
              )}
            </div>


            <div className="mb-3">
              <Input
                type="checkbox"
                id="terms"
                name="trip_t_c"
                checked={isTripDetails.trip_t_c}
                onChange={tripDetailsHandler}
              ></Input>
              {isFieldErrors.trip_t_c && (
                <p
                  className="error-message"
                  style={{ color: "red", marginTop: "5px" }}
                >
                  {isFieldErrors.trip_t_c}
                </p>
              )}
            </div>
            <div className="input-group submit">
              {/* <button
                  type="submit"
                  className="btn-custom"
                  disabled={isSubmitting}
                >
                  {isSubmitting ? "Submitting..." : "Submit"}
                </button> */}
              <button
                  type="submit"
                  className="btn-custom"
                  disabled={
                      isSubmitting ||
                      !isEmailVerified
                  }
              >
                  {isSubmitting
                      ? "Submitting..."
                      : !isEmailVerified
                      ? "Verify Email First"
                      : "Submit"}
              </button>                
            </div>
          </div>
        </form>

        <div
          className={`modal ${showModal ? "d-block" : "d-none"
            } Confirmation-modal-show`}
          tabIndex="-1"
        >
          <div className="modal-dialog">
            <div className="modal-content">
              {isProcessingPayment && (
                <div className="loader-overlay">
                  <div className="spinner-border text-success" role="status">
                    <span className="visually-hidden">Loading...</span>
                  </div>

                  <p className="mt-3 fw-bold">Processing your booking...</p>
                  <small>Please don't close or refresh this page.</small>
                </div>
              )}
              <div className="modal-header">
                <div>
                  <h5 className="modal-title">Booking Confirmation</h5>
                  <p>Below are the details of your booking</p>
                </div>
                <button
                  type="button"
                  className="btn-close"
                  aria-label="Close"
                  onClick={handleCloseModal}
                ></button>
              </div>
              <div className="modal-body">
                <div className="booking-information">
                  <div className="payment-section">
                    <h5 className="h4">Itinerary Information</h5>
                    <ul>
                      <li>
                        <span>Reference Id:</span>{" "}
                        {isTravelerData?.data?.["booking-detail"]["reference_id"]}
                      </li>
                      <li>
                        <span>Pickup Location:</span>{" "}
                        {
                          isTravelerData?.data?.["booking-detail"][
                          "pickup_location"
                          ]
                        }
                      </li>
                      <li>
                        <span>Drop Location:</span>{" "}
                        {
                          isTravelerData?.data?.["booking-detail"][
                          "drop_location"
                          ]
                        }
                      </li>
                      <li>
                        <span>Pickup Date & Time:</span>{" "}
                        {DateTimeHelper(
                          isTravelerData?.data?.["booking-detail"]["pickup_date"],
                          isTravelerData?.data?.["booking-detail"]["pickup_time"]
                        )}
                      </li>
                      <li>
                        <span>Vehicle Type:</span>{" "}
                        {
                          isTravelerData?.data?.["itinerary-detail"][
                          "vehicle_category"
                          ]
                        }
                        ,{" "}
                        {
                          isTravelerData?.data?.["itinerary-detail"][
                          "vehicle_brand"
                          ]
                        }
                      </li>
                      <li>
                        <span>Vehicle Model :</span>{" "}
                        {
                          isTravelerData?.data?.["itinerary-detail"][
                          "vehicle_model"
                          ]
                        }
                      </li>
                    </ul>
                  </div>
                  <div className="payment-section">
                    <h5 className="h4">Traveler Information</h5>
                    <ul>
                      <li>
                        <span>Full Name:</span>{" "}
                        {isTravelerData?.data?.["traveller-detail"]["title"]}{" "}
                        {isTravelerData?.data?.["traveller-detail"]["first_name"]}{" "}
                        {isTravelerData?.data?.["traveller-detail"]["last_name"]}
                      </li>
                      <li>
                        <span>Email:</span>{" "}
                        {isTravelerData?.data?.["traveller-detail"]["email"]}
                      </li>
                      {/* <li><span>Country Code:</span> {isTravelerData?.data?.["traveller-detail"]["country_code"]}</li> */}
                      <li>
                        <span>Phone No:</span>{" "}
                        {isTravelerData?.data?.["traveller-detail"]?.["country_code"]
                          ? `+${isTravelerData.data["traveller-detail"]["country_code"]} `
                          : ""}
                        {isTravelerData?.data?.["traveller-detail"]?.["phone"]}
                      </li>
                    </ul>
                  </div>
                  <div className="payment-section payment-gateway-container">
                    <h5 className="h4 pb-2 text-color-green">
                      Choose Payment Method
                    </h5>
                    <div className="confirm-section--payment--top-label mb-4">
                      {isTravelerData?.data?.paymentGateway?.map(
                        (paymentMethod, index) => (
                          <label
                            key={index}
                            className="d-flex align-items-start mb-2"
                          >
                            <input
                              type="radio"
                              id={paymentMethod.code}
                              name="payment"
                              value={paymentMethod.code}
                              onChange={() =>
                                handlePGChange(
                                  paymentMethod,
                                  isTravelerData?.data?.["transaction-detail"][
                                  "base_fare"
                                  ] +
                                  isTravelerData?.data?.["transaction-detail"][
                                  "charges"
                                  ]
                                )
                              }
                            />
                            {paymentMethod.name}
                          </label>
                        )
                      )}
                    </div>
                  </div>
                </div>
                <div className="payment-information">
                  <div className="confirm-section--payment-fare mt-0">
                    <div className="confirm-section--payment-fare-makeFlex">
                      <h4 className="h6 mb-0">Base Price</h4>
                    </div>
                    <div className="confirm-section--payment-fare-makeFlex">
                      <h3 className="h6 mb-0">

                        {" "}
                        {priceFormat(isTravelerData?.data?.["transaction-detail"][
                          "base_fare"
                        ] || 0)}
                      </h3>
                    </div>
                  </div>
                  <div className="confirm-section--payment-fare">
                    <div className="confirm-section--payment-fare-makeFlex">
                      <h4 className="h6 mb-0">Taxes Price</h4>
                    </div>
                    <div className="confirm-section--payment-fare-makeFlex">
                      <h3 className="h6 mb-0">
                        {" "}
                        {priceFormat(isTravelerData?.data?.["transaction-detail"]["charges"])}
                      </h3>
                    </div>
                  </div>
                  <div className="confirm-section--payment-fare">
                    <div className="confirm-section--payment-fare-makeFlex">
                      <h4 className="h6 mb-0">Discount</h4>
                    </div>
                    <div className="confirm-section--payment-fare-makeFlex">
                      <h3 className="h6 mb-0">
                        {" "}
                        {priceFormat(isTravelerData?.data?.["transaction-detail"]["discount"])}
                      </h3>
                    </div>
                  </div>
                  <div className="confirm-section--payment-fare">
                    <div className="confirm-section--payment-fare-makeFlex">
                      <h4 className="h6 mb-0">Convenience Fee</h4>
                    </div>
                    <div className="confirm-section--payment-fare-makeFlex">
                      <h3 className="h6 mb-0">
                        {" "}
                        {priceFormat(selectedPG.actual_convenience_value || 0)}
                      </h3>
                    </div>
                  </div>
                  <div className="confirm-section--payment-total mt-4 pt-4">
                    <div className="confirm-section--payment-fare-makeFlex">
                      <h4 className="h3 mb-0">Total</h4>
                      <p className="mb-0">inc. of tolls and taxes</p>
                    </div>
                    <div className="confirm-section--payment-fare-makeFlex">
                      <h4 className="h3 mb-0">
                        {
                          priceFormat(
                            (isTravelerData?.data?.["transaction-detail"]?.base_fare || 0) +
                            (isTravelerData?.data?.["transaction-detail"]?.charges || 0) -
                            (isTravelerData?.data?.["transaction-detail"]?.discount || 0) +
                            (selectedPG?.actual_convenience_value || 0)
                          )
                        }
                      </h4>

                    </div>
                  </div>
                </div>
              </div>
              <div className="modal-footer">
                {!isPaymentStarted && (
                  <button
                    type="button"
                    className="btn btn-custom me-3"
                    onClick={handlePayment}
                    disabled={!paymentMethodSelected}
                  >
                    Confirm Booking
                  </button>
                )}
                <button
                  type="button"
                  className="btn bth-close"
                  onClick={handleCloseModal}
                >
                  Close
                </button>
              </div>
            </div>
          </div>
        </div>
     
    </section>
  );
};

export default TripDetailsForm;
